// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".div {\n  color: red\n}\n\nbutton{\n  cursor: pointer;\n}", "",{"version":3,"sources":["webpack://./src/components/CostCenterDetails/CostCenterDetails.styles.css"],"names":[],"mappings":"AAAA;EACE;AACF;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".div {\n  color: red\n}\n\nbutton{\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
